import { useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import * as R from 'ramda';
import cx from 'classnames';
import { getIsRtl } from '../utils';
import makeStylesFn from './styles';
import CustomChip from './CustomChip';
import { myTooltipRenderer } from './utils';

var useStyles = makeStyles(makeStylesFn);

var GroupedChips = function GroupedChips(_ref) {
  var _ref$itemProps = _ref.itemProps,
      itemProps = _ref$itemProps === undefined ? {} : _ref$itemProps,
      onDelete = _ref.onDelete,
      _ref$labelRenderer = _ref.labelRenderer,
      labelRenderer = _ref$labelRenderer === undefined ? R.prop('label') : _ref$labelRenderer,
      tooltipRenderer = _ref.tooltipRenderer,
      ariaLabel = _ref.ariaLabel,
      _ref$reducingNbChips = _ref.reducingNbChips,
      reducingNbChips = _ref$reducingNbChips === undefined ? 15 : _ref$reducingNbChips,
      labels = _ref.labels,
      _ref$testId = _ref.testId,
      testId = _ref$testId === undefined ? 'chips-test-id' : _ref$testId,
      _ref$ariaLabelTooltip = _ref.ariaLabelTooltip,
      ariaLabelTooltip = _ref$ariaLabelTooltip === undefined ? ' parent of ' : _ref$ariaLabelTooltip;
  var parentId = itemProps.id,
      isNotRemovable = itemProps.isNotRemovable,
      _itemProps$values = itemProps.values,
      values = _itemProps$values === undefined ? [] : _itemProps$values;

  var theme = useTheme();
  var isRtl = getIsRtl(theme);
  var classes = useStyles();

  return React.createElement(
    Fragment,
    null,
    React.createElement(CustomChip, {
      testId: testId,
      parentId: parentId,
      label: labelRenderer(itemProps) + ':',
      ariaLabel: ariaLabel,
      chipClasses: cx(classes.mainChip, classes.chip),
      onDelete: isNotRemovable ? null : onDelete,
      iconClasses: classes.icon,
      labelClasses: cx(classes.spaceLabel, classes.formatLabel)
    }),
    R.pipe(R.length, R.flip(R.gt)(reducingNbChips))(values) ? React.createElement(CustomChip, {
      parentId: parentId,
      label: R.length(values) + ' ' + R.prop('reducingChip')(labels),
      chipClasses: cx(classes.secondaryChip, classes.chip),
      onDelete: isNotRemovable ? null : onDelete,
      iconClasses: classes.icon,
      labelClasses: cx(classes.spaceLabel, classes.formatLabel)
    }) : R.map(function (items) {
      var lastItem = R.last(items);
      var id = lastItem.id,
          isNotRemovable = lastItem.isNotRemovable,
          deprecated = lastItem.deprecated;


      return React.createElement(CustomChip, {
        deprecated: deprecated,
        key: id,
        id: id,
        items: R.pipe(R.length, R.gte(2)) ? items : null,
        renderer: R.is(Function)(tooltipRenderer) ? tooltipRenderer : myTooltipRenderer({ isRtl: isRtl, labelRenderer: labelRenderer }),
        label: labelRenderer(lastItem),
        labelRenderer: labelRenderer,
        ariaLabel: ariaLabel,
        parentId: parentId,
        onDelete: isNotRemovable ? null : onDelete,
        chipClasses: cx(classes.secondaryChip, classes.chip),
        iconClasses: classes.icon,
        labelClasses: cx(classes.spaceLabel, classes.formatLabel),
        ariaLabelTooltip: ariaLabelTooltip
      });
    })(values)
  );
};
GroupedChips.propTypes = process.env.NODE_ENV !== "production" ? {
  testId: PropTypes.string,
  itemProps: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    isNotRemovable: PropTypes.bool,
    values: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      isNotRemovable: PropTypes.bool
    })))
  }),
  onDelete: PropTypes.func,
  labelRenderer: PropTypes.func,
  tooltipRenderer: PropTypes.func,
  ariaLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  reducingNbChips: PropTypes.number,
  labels: PropTypes.shape({
    reducingChip: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
  }),
  ariaLabelTooltip: PropTypes.string
} : {};
export default GroupedChips;